import { jsx as _jsx } from "react/jsx-runtime";
import Icon from '@jetbrains/ring-ui/components/icon';
import helpIcon from '@jetbrains/icons/help';
import classNames from 'classnames';
import styles from './help-icon.css';
function HelpIcon({ className, ...restProps }) {
    return (_jsx(Icon, { glyph: helpIcon, className: classNames(styles.helpIcon, className), ...restProps }));
}
export default HelpIcon;
